export default "__VITE_PUBLIC_ASSET__dff185cf__"